import React from "react";
// import { TextField } from "@material-ui/core";
import useAutocomplete from "@material-ui/lab/useAutocomplete";
// import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckIcon from "@material-ui/icons/Check";
// import CloseIcon from "@material-ui/icons/Close";
import { InputLabel } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import clsx from "clsx";
import { DynamicFormFieldProps } from "../DynamicForm";
import { DynamicFormField } from "../../laco-common/base/form-validation/dynamic";
import { FormLabel } from ".";
import "./ChipsInput.scss";

type ChipsInputProps = {};

// const Tag = ({ label, onDelete, ...props }: any) => (
// 	<div {...props} className="chips-input-tag">
// 		<span>{label}</span>
// 		<CloseIcon onClick={onDelete} />
// 	</div>
// );

export default function ChipsInput(props: DynamicFormFieldProps & ChipsInputProps & any) {
	const field: DynamicFormField = props.field;
	const { index, onChange, onBlur, processing, getHelperText, omitLabel, skipAutoFocus } = props;
	const datasource = field.datasource || [];
	const nameField: string = field.nameField || "name";
	const valueField: string = field.valueField || "value";

	const getOptionLabel = (option) => {
		return ((field.getOptionDisplay ? field.getOptionDisplay(option) : option[nameField]) || "").toString();
	};
	const {
		getRootProps,
		getInputProps,
		getTagProps,
		getListboxProps,
		getOptionProps,
		groupedOptions,
		value,
		focused,
		setAnchorEl,
	} = useAutocomplete({
		id: field.key,
		value: field.value,
		multiple: true,
		freeSolo: field.freeSolo,
		autoSelect: field.freeSolo,
		disableClearable: field.freeSolo,
		options: datasource,
		getOptionLabel,
		getOptionSelected: field.getOptionSelected,
		onChange: (e, value, reason, details) => {
			const selected = value.map((option) => {
				if (option && typeof option === "object") {
					return option[valueField];
				}
				return option;
			});
			console.log("ChipsInput onChange(): selected:", selected);
			onChange(selected);
		},
	});

	// return (
	// 	<Autocomplete
	// 		multiple
	// 		limitTags={2}
	// 		id="multiple-limit-tags"
	// 		options={datasource}
	// 		getOptionLabel={getOptionLabel}
	// 		defaultValue={field.value}
	// 		freeSolo={field.freeSolo}
	// 		disableClearable
	// 		autoSelect
	// 		onChange={(e, value, reason, details) => {
	//
	// 		}}
	// 		renderInput={(params) => (
	// 			<TextField {...params} variant="outlined" label="limitTags" placeholder="Favorites" />
	// 		)}
	// 	/>
	// );

	return (
		<div className="chips-input-container">
			<div {...getRootProps()} className="MuiFormControl-root MuiTextField-root w-100">
				{!omitLabel && (
					<div style={{ height: "20px" }}>
						{/* getInputLabelProps ariel */}
						<InputLabel
							htmlFor={field.key}
							data-shrink={focused}
							className={clsx(
								(focused || field.value?.length > 0) && "MuiInputLabel-shrink",
								focused && "Mui-focused",
								!!field.value && "MuiFormLabel-filled",
								// !field.valid && field.touched && "Mui-error",
								"w-100 MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated"
							)}
						>
							<FormLabel field={field} />
						</InputLabel>
					</div>
				)}
				<div
					className={clsx(
						"chips-input-wrapper",
						focused && "focused",
						!field.valid && field.touched && "Mui-error"
					)}
					ref={setAnchorEl}
				>
					{(value || []).map((option, index: number) => (
						// <Tag label={getOptionLabel(option)} {...getTagProps({ index })} />
						<Chip
							className="chips-input-tag"
							variant="outlined"
							label={getOptionLabel(option)}
							{...getTagProps({ index })}
							style={{ marginBottom: "3px", marginRight: "2px" }}
							disabled={field.disabled}
							key={option.id}
						/>
					))}
					{/* <TextField
						{...getInputProps()}
						onBlur={onBlur}
						autoFocus={index === 0 && !skipAutoFocus}
						placeholder={!field.value || !field.value.length ? field.placeholder : ""}
						helperText={getHelperText ? getHelperText(field) : undefined}
					></TextField> */}
					<input
						{...getInputProps()}
						onBlur={onBlur}
						autoFocus={index === 0 && !skipAutoFocus}
						placeholder={!field.value || !field.value.length ? field.placeholder : ""}
						disabled={field.disabled}
						// helperText={getHelperText ? getHelperText(field) : undefined}
					/>
				</div>
				{!field.valid && (
					<p
						className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error MuiFormHelperText-filled"
						style={{ fontSize: "12px", color: "rgba(238, 17, 17, 0.95)", margin: 0, marginTop: "3px" }}
					>
						{!!getHelperText && getHelperText(field)}
					</p>
				)}
			</div>
			{!field.disabled && groupedOptions.length > 0 ? (
				<ul {...getListboxProps()} className="chips-input-listbox MuiList-root MuiMenu-list MuiList-padding">
					{groupedOptions.map((option, index: number) => (
						<li
							className="MuiButtonBase-root MuiListItem-root MuiMenuItem-root MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button"
							{...getOptionProps({ option, index })}
						>
							<span>{getOptionLabel(option)}</span>
							<CheckIcon fontSize="small" />
						</li>
					))}
				</ul>
			) : null}
		</div>
	);
}
